export enum LegacySupportPaths {
  overview = '/console/support',
  create = '/console/support/tickets/create',
  history = '/console/support/tickets',
  supportPlans = '/console/support/plans',
  /**
   * Fake path that allows useOscRedirect to open OSC in the same tab
   * when a user is logging in from OSC. Temporary workaround until
   * deeplinking functionality in Console Navigation Backend is updated
   * to support 'help' subdomain
   */
  login = '/console/support/login',
  loginToSubmit = '/console/support/login-submit',
}

export enum KnowledgeBaseUrlKey {
  article = 'article',
  category = 'category',
  section = 'section',
  articleAttachments = 'articleAttachments',
}
